import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { LocalStorageService } from 'ngx-webstorage';

export const storageKeys = {
  TOKEN: 'token',
  EMAIL: 'username',
};

export function isLogged(localStorage: LocalStorageService): boolean {
  return !!localStorage.retrieve(storageKeys.TOKEN);
}

export const REGEX = {
  codiceFiscale:
    /^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/,
  email: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
  password:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z0-9$@$!%*?&]{8,}$/,
  nameSurname: /^[A-Za-zÀ-ÿà-ÿ]+$/,
  phone: /^(\+39)?\s?\d{3}[\s\-]?\d{6,7}$/,
  cap:/^\d{5}$/ 
};

//validatore per 11 cifre numeriche 
export function vatNumberValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  // Controlla che sia una stringa di 11 cifre numeriche
  const isValid = /^\d{11}$/.test(value);
  return isValid ? null : { invalidPartitaIva: true };
}

//validatore per sole lettere
export function onlyLettersValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  const regex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]*$/; // supporta lettere accentate e spazi
  return regex.test(value) ? null : { onlyLetters: true };
}

//Validatore per il controllo dell orario di chiusura che deve essere superiore a quello di apertura della struttura
export function timeAfterValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const open = control.get('openingTime')?.value;
    const close = control.get('closingTime')?.value;

    if (open && close) {
      // Converto l'orario in minuti dall'inizio della giornata (00:00)
      const [openHour, openMinute] = open.split(':').map(Number);
      const [closeHour, closeMinute] = close.split(':').map(Number);

      const openTimeInMinutes = openHour * 60 + openMinute;
      const closeTimeInMinutes = closeHour * 60 + closeMinute;

      // Confronto per assicurarmi che l'orario di chiusura sia maggiore di quello di apertura
      if (closeTimeInMinutes <= openTimeInMinutes) {
        return { timeAfter: true }; // Errore se l'orario di chiusura è minore o uguale a quello di apertura
      }
    }

    return null; // Valido se non ci sono errori
  };
}

